import React, { ReactElement, useMemo, useState } from "react";
import Chart from "react-apexcharts";
import { StatsService } from "../../stats";

export const SalesByRepBar = (props: any): ReactElement => {
	const [sales, setSales] = useState([]);
	const statsService = new StatsService();

	useMemo(() => {
		const fetchSales = async () => {
			const salesStats = await statsService.findSalesStatsByRep(
				props.date,
			);
			setSales(salesStats.salesByRep);
		};

		fetchSales();
	}, [props.date]);

	return (
		<div className="text-center">
			<h1>Sales By Rep</h1>
			<Chart
				options={{
					xaxis: {
						categories: sales.map(
							(rep: any) => `${rep.first_name} ${rep.last_name}`,
						),
					},
					plotOptions: {
						bar: {
							borderRadius: 2,
							horizontal: true,
						},
					},
					colors: [
						"#69d2e7",
						"#33b2df",
						"#546E7A",
						"#d4526e",
						"#13d8aa",
						"#A5978B",
						"#2b908f",
						"#f9a3a4",
						"#90ee7e",
						"#f48024",
					],
					dataLabels: {
						enabled: false,
					},
				}}
				series={[
					{
						name: "sales",
						data: sales.map((rep: any) => rep.total_sales),
					},
				]}
				type="bar"
			/>
		</div>
	);
};
